export default "__VITE_ASSET__786320d8__"